import DataTableHeaderConverter from '@/constants/DataTableHeaderConverter';
import { numberToColumn } from '@/utils/etc';
import { actionMakeTotalData } from '@/utils/stats';
/**
 * 매출 추상 클래스
 * 엑셀 데이터와 페이지 데이터가 같이 있음 요주의
 */
export default class AbsSales {
    /** [엑셀관련] 본문 부분 정렬 */
    excelBodyCellAlign = {};
    /** [엑셀관련] 총계 셀 인덱스 A, B, C ... */
    excelTotalCellIndex = [];
    /** [페이지] 헤더 콘피그 */
    tableHeaderData = null;
    /**
     * [페이지] 헤더 데이터
     * */
    initPageHeaderData() {
        this.tableHeaderData = new DataTableHeaderConverter(this.pageHeaderData);
    }
    /**
     * [엑셀] 헤더 데이터를 활요하여 엑셀 정렬 데이터 생성
     */
    initExcelConfig() {
        this.excelBodyCellAlign = this.tableHeaderData.cellAlign
            .reduce((acc, curr, index) => {
            const column = numberToColumn(index);
            acc[column] = curr;
            if (curr === 'ta-r') {
                acc[column] = 'right';
            }
            else if (curr === 'ta-c') {
                acc[column] = 'center';
            }
            else if (curr === 'ta-l') {
                acc[column] = 'left';
            }
            return acc;
        }, {});
        this.excelTotalCellIndex = this.tableHeaderData.totalKeyList
            .reduce((acc, v, index) => {
            if (v) {
                acc.push(numberToColumn(index));
            }
            return acc;
        }, []);
    }
    /** 합계 데이터 생성 */
    makeTotalData(statsData) {
        return actionMakeTotalData(statsData, this.tableHeaderData.totalKeyList);
    }
    /** [엑셀관련] 데이터 필드 생성 */
    getExcelDataField(item) {
        return this.tableHeaderData.bodyKeyList.map((v) => item[v]);
    }
}
